import React from 'react';
import { CarIcon, GasPump, InfoIcon, UserIcon } from '../../icons';
// import { useDriversByPlateNumber } from '../../hooks/react-query/useDrivers';
import { CardTag } from '../ui';

const CarInfoCard = ({ carData, carRef, driverId }) => {
  const { EndDate, FuelType, ModelName, MakeName, plateno } = carData || {};
  // const { data = {} } = useDriversByPlateNumber(plateno);
  // const driverAssignedCount = data?.data?.length || 0;
  const carDetails = {
    ...carData,
    title: carData.MakeName,
    subTitle: carData?.plateno,
  };
  // const isAssigned = data?.data?.some((driverData) => !!driverData.isPrimary);
  return (
    <div className="bg-white rounded-xl" ref={carRef}>
      <div className="card-header pe-3">
        <CardTag id={plateno} carData={carDetails} isAssignedView={true} />
      </div>
      <div className="card-body px-5 pt-3.5 pb-5">
        <div className="flex flex-col  gap-3">
          <div className="flex flex-col gap-2">
            {/*  <div className="flex items-center gap-2">
              <UserIcon className="stroke-black" />
              <span className="text-body">{driverAssignedCount}</span>
            </div> */}
            <div className="flex items-center gap-2">
              <GasPump />
              {FuelType}
            </div>
            <div className="flex items-center gap-2">
              <CarIcon color="black" />
              <span className="text-body"> {ModelName}</span>
            </div> 
          </div>
          <div className="flex gap-2 text-disclaimer text-grenite">
            <InfoIcon />
            <span className="text-body">Λήξη συμβολαίου: {EndDate.split('-')[2]+'/'+EndDate.split('-')[1]+'/'+EndDate.split('-')[0]}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarInfoCard;
